import React from 'react'

import HTML from '../assets/html.png'
import CSS from '../assets/css.png'
import JavaScript from '../assets/javascript.png'
import ReactImg from '../assets/react.png'
import Node from '../assets/node.png'
import FireBase from '../assets/firebase.png'
import AWS from '../assets/aws.png'
import GitHub from '../assets/github.png'
import Tailwind from '../assets/tailwind.png'
import Mongo from '../assets/mongo.png'
import PHP from '../assets/php.png'
import MySQL from '../assets/mysql.png'
import Python from '../assets/python.png'
import Java from '../assets/java.png'
import CSharp from '../assets/csharp.png'
import Unity from '../assets/unity.png'
import Blender from '../assets/blender.png'

const skills = () => {
  return (
    <div name='skills' className='w-full h-screen bg-[#230552] text-gray-300 pt-96 py-[600px]'>
      
      <div className='max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full h-auto sm:h-full '>
        <div>
          <p className='text-4xl font-bold inline border-b-4 border-blue-600'>Skills</p>
          <p className='py-4'> There are the technologies I've worked with</p>
        </div>

         {/*Images */}
        <div className='w-full grid grid-cols-2 sm:grid-cols-4 gap-4 text-center py-8'>
          <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
            <img className='w-20 mx-auto' src={ReactImg} alt="HTML_Image" />
            <p className='my-4'>React JS</p>
          </div>
          <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
            <img className='w-20 mx-auto' src={PHP} alt="HTML_Image" />
            <p className='my-4'>PHP</p>
          </div>
          <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
            <img className='w-20 mx-auto' src={MySQL} alt="HTML_Image" />
            <p className='my-4'>MySQL</p>
          </div>
          <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
            <img className='w-20 mx-auto' src={Tailwind} alt="HTML_Image" />
            <p className='my-4'>Tailwind</p>
          </div>
          <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
            <img className='w-20 mx-auto' src={Python} alt="HTML_Image" />
            <p className='my-4'>Python</p>
          </div>
          <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
            <img className='w-20 mx-auto' src={CSharp} alt="HTML_Image" />
            <p className='my-4'>C#</p>
          </div>
          <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
            <img className='w-20 mx-auto' src={Unity} alt="HTML_Image" />
            <p className='my-4'>Unity</p>
          </div>
          <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
            <img className='w-20 mx-auto' src={Blender} alt="HTML_Image" />
            <p className='my-4'>Blender</p>
          </div>
        </div>

      </div>
      
    </div>
  )
}

export default skills